import './assets/style.css'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
import { useEasterEggStore } from '@brixcrm/vue-kit'
import { AxiosError } from 'axios'
import { pinia } from '@/pinia'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@/setup/fontawesome'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import dayjs from 'dayjs'

import nl from 'dayjs/locale/nl'
import { setupSentry } from '@/setup/sentry'

dayjs.extend(localizedFormat)
dayjs.locale(nl)

const app = createApp(App)

setupSentry(app)

app.use(pinia)
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')

const authStore = useAuthStore()
void authStore.checkTokenExpirationOnLoad()
authStore.registerNearingExpirationTimeout()

app.config.errorHandler = (error) => {
  if (error instanceof AxiosError) {
    // leave it
  } else {
    throw error
  }
}

const easterEggStore = useEasterEggStore()
easterEggStore.setKonamiListener(document.body)
easterEggStore.setEasterEggHandler(() => {
  const elements = document.querySelectorAll('body')
  elements.forEach((element) => {
    element.classList.add('animate-drunken')
  })
})
